import { render, staticRenderFns } from "./footer-yfh.vue?vue&type=template&id=1cec41b4&scoped=true&"
import script from "./footer-yfh.vue?vue&type=script&lang=js&"
export * from "./footer-yfh.vue?vue&type=script&lang=js&"
import style0 from "./footer-yfh.vue?vue&type=style&index=0&id=1cec41b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec41b4",
  null
  
)

export default component.exports